/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Plan_Prep_ForInputs */

const en_plan_prep_for = /** @type {(inputs: Plan_Prep_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`for ${i?.title} tomorrow`)
};

const de_plan_prep_for = /** @type {(inputs: Plan_Prep_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`für ${i?.title} morgen`)
};

/**
* | output |
* | --- |
* | "for {title} tomorrow" |
*
* @param {Plan_Prep_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_prep_for = /** @type {((inputs: Plan_Prep_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Prep_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_prep_for(inputs)
	return en_plan_prep_for(inputs)
});